import { isEmail } from 'validator';

import {
  isDayMonthYearADate,
  validateMinimumAge,
  isValidBirthDate
} from 'common/helpers/dateHelper';
import { validateForUI } from 'common/helpers/jsonValidator';
import { getMinimumAge } from 'common/helpers/miscHelper';
import { isValidPhoneNumber } from 'common/helpers/phoneHelper';

const emails = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      email: { type: 'string' }
    },
    required: ['email'],
    additionalProperties: false
  }
};

const phones = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      phone: { type: 'string' }
    },
    required: ['phone'],
    additionalProperties: false
  }
};

const customerSchema = {
  type: 'object',
  properties: {
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    // birthDate: { type: 'string' },
    birthDay: { type: 'integer' },
    birthMonth: { type: 'integer' },
    birthYear: { type: 'integer' },
    city: { type: 'string' },
    stateCode: { type: 'string' },
    countryCode: { type: 'string', maxLength: 2, minLength: 2 },
    emails,
    phones,
    emailMarketingStatus: { type: 'string' }
  },
  required: [
    'firstName',
    'lastName',
    'birthDay',
    'birthMonth',
    'birthYear',
    'countryCode',
    'emails',
    'phones'
  ],
  additionalProperties: false
};

const passwordSchema = {
  type: 'object',
  properties: {
    currentPassword: { type: 'string', minLength: 8 },
    password: { type: 'string', minLength: 8 },
    confirmPassword: { type: 'string', minLength: 8 }
  },
  required: ['password', 'confirmPassword'],
  additionalProperties: false
};

export const validateEdit = (customer, settings) => {
  const errors = validateForUI(
    customerSchema,
    customer,
    customValidate(customer, settings)
  );
  return errors;
};

export const validatePassword = (password) => {
  const errors = validateForUI(
    passwordSchema,
    password,
    customPasswordValidate(password)
  );
  return errors;
};

const customValidate = (customer, settings) => {
  const errorArray = [];
  if (customer.emails) {
    for (let i = 0; i < customer.emails.length; i += 1) {
      if (customer.emails[i].email && !isEmail(customer.emails[i].email)) {
        const error = { field: `emails[${i}].email`, message: 'Invalid Email' };
        errorArray.push(error);
      }
    }
    if (customer.emails.length === 0) {
      const error = {
        field: `emails[0].email`,
        message: 'At least one email is required'
      };
      errorArray.push(error);
    }
  }
  if (customer.birthDay && (customer.birthDay < 1 || customer.birthDay > 31)) {
    const error = { field: 'birthDay', message: 'Invalid Day' };
    errorArray.push(error);
  }
  if (
    customer.birthMonth &&
    (customer.birthMonth < 1 || customer.birthMonth > 12)
  ) {
    const error = { field: 'birthMonth', message: 'Invalid Month' };
    errorArray.push(error);
  }
  if (
    customer.birthYear &&
    (customer.birthYear < 1900 || customer.birthYear > 2020)
  ) {
    const error = { field: 'birthYear', message: 'Invalid Year' };
    errorArray.push(error);
  }
  if (customer.birthDay && customer.birthMonth && customer.birthYear) {
    if (
      !isDayMonthYearADate(
        customer.birthDay,
        customer.birthMonth,
        customer.birthYear
      )
    ) {
      const error = { field: 'birthDay', message: 'Invalid Day' };
      errorArray.push(error);
    }

    const isMinimumAge = validateMinimumAge(
      customer.birthDay,
      customer.birthMonth,
      customer.birthYear,
      settings
    );

    if (!isMinimumAge) {
      const minAge = getMinimumAge(settings);
      const error = {
        field: 'birthYear',
        message: `Must be at least ${minAge} years old`
      };
      errorArray.push(error);
    }

    if (
      !isValidBirthDate(customer.birthDay, customer.month, customer.birthYear)
    ) {
      const error = {
        field: 'birthYear',
        message: `Invalid birth date`
      };
      errorArray.push(error);
    }
  }

  if (customer.phones && customer.countryCode) {
    for (let i = 0; i < customer.phones.length; i += 1) {
      if (
        customer.phones[i].phone &&
        !isValidPhoneNumber(
          customer.phones[i].phone,
          customer.countryCode,
          settings
        )
      ) {
        errorArray.push({
          field: `phones[${i}].phone`,
          message: 'Invalid phone number for your country code'
        });
      }
    }
    if (customer.phones.length === 0) {
      const error = {
        field: `phones[0].phone`,
        message: 'At least one phone number is required'
      };
      errorArray.push(error);
    }
  }
  if (customer.phones && !customer.countryCode) {
    for (let i = 0; i < customer.phones.length; i += 1) {
      errorArray.push({
        field: `phones[${i}].phone`,
        message: 'Invalid phone number for your country code'
      });
    }
  }
  return errorArray;
};

const customPasswordValidate = (customer) => {
  const errorArray = [];
  if (customer.password !== customer.confirmPassword) {
    const error = {
      field: 'confirmPassword',
      message: 'Confirm Password must match Password'
    };
    errorArray.push(error);
  }
  return errorArray;
};
